export const getSearchParam = (
  key: string,
  searchParams?: Record<string, string | string[] | undefined>,
) => {
  if (!searchParams) return undefined;

  const value = searchParams[key];

  if (value === undefined) return undefined;
  if (Array.isArray(value)) return value[0];

  return value;
};
